import { EmptyFolderContainer } from "./EmptyFolder.styled";

const EmptyFolder = () => {
    return <EmptyFolderContainer>Folder is empty</EmptyFolderContainer>;
};

export default EmptyFolder;